import { ICursorElements } from '@/store/types/search.types';

import { IFilterOnboardingUser, IOnboardingUser } from '@/store/models/onboarding-user.model';
import { getStaticDashboardConfig } from '@/hooks/useDashboardConfig';

import { get } from './FetchServices';

export class OnboardingUserService {
  static queryKey = 'OnboardingUser';
  static fetchOnboardingUsers = async (filter?: IFilterOnboardingUser): Promise<ICursorElements<IOnboardingUser>> => {
    try {
      const config = getStaticDashboardConfig();

      const url = new URL(`${config.api.baseUrl}/core-connect/onboarding/users?`);
      url.searchParams.append('pageSize', '24');

      filter?.cursor && url.searchParams.append('cursor', filter.cursor);
      filter?.type && url.searchParams.append('onboardingComplete', filter.type === 'completed' ? '1' : '0');

      return await get(
        { url: url.toString(), action: this.queryKey, searchParams: url.searchParams },
        {
          shouldSkipEncryption: true,
          hasCursor: true,
        },
      );
    } catch (err) {
      return Promise.reject(err);
    }
  };
}
